module.exports = __webpack_public_path__ + "static/img/7.e8e01c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/7.jpg
// module id = ZoAn
// module chunks = 1